import { lazy } from "react";
import { Navigate, Outlet, Route, Routes } from "react-router-dom";
import PrivateLayout from "./Layouts/private/PrivateLayout";
import MagicLink from "./pages/MagicLink/MagicLink";
import { routesList } from "./routesList";

const HomeView = lazy(() => import("./pages/Home/HomeView"));

const LoginView = lazy(() => import("./pages/Login/LoginView"));
const LogoutView = lazy(() => import("./pages/Logout/LogoutView"));
const RepairView = lazy(() => import("./pages/Repair/RepairView"));
const RegisterView = lazy(() => import("./pages/Register/RegisterView"));

const CrewInvitation = lazy(() => import("./pages/CrewInvitation/CrewInvitationView"));
const ItemsView = lazy(() => import("./pages/Items/ItemsView"));
const MementosView = lazy(() => import("./pages/Mementos/MementosView"));

const EconomosHomeView = lazy(
	() => import("./pages/Economos/Dashboard/EconomosMovementsDashboard"),
);
const EconomosMovementsView = lazy(
	() => import("./pages/Economos/Movements/EconomosMovementsView"),
);
const EconomosSearchView = lazy(() => import("./pages/Economos/Search/EconomosSearchView"));

const OnboardingGroup = lazy(() => import("./pages/Onboarding/GroupView"));
const Settings = lazy(() => import("./pages/Settings/Settings"));

const HealbotView = lazy(() => import("./pages/Healbot/HealbotView"));

const SplitExpensesView = lazy(() => import("./pages/SplitExpenses/SplitExpensesView"));
const SplitExpensesGroupView = lazy(() => import("./pages/SplitExpenses/SplitExpensesGroupView"));

export function RoutesGroup() {
	return (
		<Routes>
			{/* ********************************** */}
			{/* Public routes */}
			{/* ********************************** */}
			<Route
			// element={<WebHeader><Outlet /></WebHeader>}
			>
				<Route path={routesList.home.path} element={<HomeView />} />

				<Route path={routesList.login.path} element={<LoginView />} />
				<Route path={routesList.logout.path} element={<LogoutView />} />
				<Route path={routesList.repair.path} element={<RepairView />} />
				<Route path={routesList.magicLink.path} element={<MagicLink />} />

				<Route path={routesList.register.path} element={<RegisterView />} />
			</Route>

			{/* ********************************** */}
			{/* Layoutless routes */}
			{/* ********************************** */}

			<Route path={routesList.crewInvitation.path} element={<CrewInvitation />} />

			<Route path={routesList.healbot.path} element={<HealbotView />} />

			{/* ********************************** */}
			{/* Private routes */}
			{/* ********************************** */}

			<Route
				element={
					<PrivateLayout>
						<Outlet />
					</PrivateLayout>
				}
			>
				<Route path="/eidos" element={<Navigate to={routesList.items.path} replace />} />
				<Route path={routesList.items.path} element={<ItemsView />} />
				<Route path={routesList.mementos.path} element={<MementosView />} />

				<Route path={routesList.economos.path} element={<EconomosHomeView />} />
				<Route
					path={routesList.economosMovements.path}
					element={<EconomosMovementsView />}
				/>
				<Route path={routesList.economosSearch.path} element={<EconomosSearchView />} />

				<Route path={routesList.onboardingGroup.path} element={<OnboardingGroup />} />

				<Route path={routesList.settings.path} element={<Settings />} />

				<Route path={routesList.split.path} element={<SplitExpensesGroupView />} />
				<Route path={routesList.splitGroup.path} element={<SplitExpensesView />} />
			</Route>
		</Routes>
	);
}
